<template>
    <div>
        <div class="card" v-if="registerEntityId && loaded">
            <div class="card-header">
                <div class="card-title h5 m-0">
                    {{ $t('eventDescription.connectedEventData') }}
                </div>
            </div>
            <div class="card-body row">
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.eventName') }}</label>
                    <div class="text-muted">{{ data.name }}</div>
                </div>
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.eventPlace') }}</label >
                    <div class="text-muted">{{ data.place }}</div>
                </div>
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.startDate') }}</label >
                    <DatetimePicker v-model="data.startDate" :readonly="true"></DatetimePicker>
                </div>
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.endDate') }}</label >
                    <DatetimePicker v-model="data.endDate" :readonly="true"></DatetimePicker>
                </div>
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.project') }}</label >
                    <div class="text-muted">{{ data.projectName }}</div>
                </div>
                <div class="col-md-6 mt-3">
                    <label  class="font-weight-bold">{{ $t('eventDescription.organizer') }}</label >
                    <div class="text-muted">{{ data.organizer }}</div>
                </div>

                <div class="col-12 mt-3" v-if="data.lecturers && data.lecturers.length > 0">
                    <label  class="font-weight-bold">{{ $t('eventDescription.lecturers') }}</label >
                    <div>
                        <span class="badge badge-pill badge-light mr-1 ml-1"
                            v-for="(lecturer, index) in data.lecturers"
                            :key="index"
                        >
                        <h6 class="m-0">{{ lecturer }}</h6>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 import { EventDescription } from '@/models/models';
 import DatetimePicker from '@/components/datepicker/DateTimePicker';
 import { mapGetters } from 'vuex'

 export default {
     props: {
         registerEntityId: {
             type: [Number, String]
         }
     },
     components: {
         DatetimePicker
     },
     data() {
         return {
             loaded: false,
             data: new EventDescription()
         }
     },
     methods: {
         loadData() {
             this.$http.get(`/api/DynamicForms/GetEventDescription/${this.registerEntityId}`).then(result => {
                 if (result.data) {
                     this.data = new EventDescription(result.data);
                 }
                 this.loaded = true;
             }).catch(error => {
                 // TODO:
                 this.loaded = true;
             });
         }
     },
     computed: {
         ...mapGetters(['isEnVersion']),
     },
     mounted () {
         this.loadData();
     }
 }
</script>

<style scoped></style>
